import Phaser from 'phaser';
import { DEFAULT_GEODE } from '../constants';
import { getGeodeSyncEntry } from '../server-state';

export const MENU_GEODE_BUTTONS = [
  { geodeType: 'Dust Geode', file: 'Dust.png', key: 'menu-geode-dust' },
  { geodeType: 'Space Rock', file: 'SpaceRock.png', key: 'menu-geode-spacerock' },
  { geodeType: 'Amber', file: 'Amber.png', key: 'menu-geode-amber' },
  { geodeType: 'Gold', file: 'Gold.png', key: 'menu-geode-gold' },
  { geodeType: 'Lava', file: 'Lava.png', key: 'menu-geode-lava' },
  { geodeType: 'Quartz', file: 'Quartz.png', key: 'menu-geode-quartz' },
  { geodeType: 'Sand', file: 'Sand.png', key: 'menu-geode-sand' },
] as const;

const DEFAULT_MENU_GEODE_KEY = MENU_GEODE_BUTTONS[0].key;

export function queueMenuGeodeIconsLoad(scene: Phaser.Scene) {
  for (const { file, key } of MENU_GEODE_BUTTONS) {
    scene.load.image(key, `menu/Main-Buttons/${file}`);
  }
}

export function menuGeodeTextureKey(geodeType: string) {
  const match = MENU_GEODE_BUTTONS.find((entry) => entry.geodeType === geodeType);
  return match?.key ?? DEFAULT_MENU_GEODE_KEY;
}

export function currentGeodeType() {
  return getGeodeSyncEntry()?.geodeType ?? DEFAULT_GEODE;
}
